import React, { useRef } from 'react';
import { useOutsideClick } from '@citygross/utils';
import { Icons } from '@citygross/icons';
import { DialogContainer, DialogClose } from './ToolTipDialog.styles.js';

var ToolTipDialog = function ToolTipDialog(_a) {
  var info = _a.info,
      toggle = _a.toggle,
      onBottom = _a.onBottom;
  var infoRef = useRef(null);
  useOutsideClick(infoRef, function () {
    return toggle();
  });
  return React.createElement(DialogContainer, {
    ref: infoRef,
    onBottom: onBottom
  }, info, React.createElement(DialogClose, {
    onClick: toggle
  }, React.createElement(Icons.Cross, {
    height: 20,
    width: 20,
    color: "white"
  })));
};

export { ToolTipDialog };